import { Model } from "@vuex-orm/core";
import config from "../configs/Contact";

export default class Contact extends Model {
  static get entity() {
    return "contacts";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      building_id: this.attr(null),
      zipcode: this.attr(null),
      city: this.attr(null),
      country: this.attr(null),
      contact_type: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..
      can_vote: this.attr(null),
      entity_type: this.attr(null),
      gender: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      phone: this.attr(null),
      email: this.attr(null),
      user_id: this.attr(null),
      username: this.attr(null),
      password: this.attr(null),
      address: this.attr(null),
      complement: this.attr(null),
      complement2: this.attr(null),
      // NOTE: Used only locally
      is_selected: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
